import './calls.scss';
import React, { useState } from 'react';
import { Chart, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Row, Col, Form, InputGroup, Button, Dropdown } from 'react-bootstrap';
import 'react-tabs/style/react-tabs.css';
//import { ReactTyped } from 'react-typed'; // Ensure correct import
import img_nextGPT from '../../images/svg/calls_nextgpt.svg';
import img_callFollowup from '../../images/svg/calls_followup.svg';
import img_callAssessment from '../../images/svg/calls_assessment.svg';
import summmaryClickIcon from '../../images/svg/summaryclickicon.svg';
import qaClickIcon from '../../images/svg/qaclickicon.svg';
import sendMessageIcon from '../../images/svg/sendmessage.svg';
import trainingPlanIcon from '../../images/svg/trainingplanicon.svg';
import idealConversationIcon from '../../images/svg/idealconversationicon.svg';
import CallSummary from '../dashboard/nextgpt/callSummary.js';
import QAPerformance from '../dashboard/nextgpt/qaPerformance.js';
//import smList from '../../mocks/profiles/smList.json';
import TrainingPlans from '../dashboard/nextgpt/trainingPlans.js';
import IdealConversation from '../dashboard/nextgpt/idealConversation.js';
import Assistant from '../dashboard/nextgpt/assistant.js';

Chart.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const options = {
  scales: {
    r: {
      angleLines: {
        display: true // Display the lines pointing to each attribute
      },
      beginAtZero: false, // Ensure the scale does not start from zero
      min: -25, // Set the minimum value to -25
      max: 100, // Set the maximum value to 100
      gridLines: {
        circular: true, // Draw circular grid lines
        borderDash: [6], // Add dashed lines for non-zero values (optional)
        borderDashOffset: 5 // Adjust dash offset for line style (optional)
      },
      ticks: {
        stepSize: 25,
        backgroundColor: 'rgba(7, 115, 234, 0.2)', // Remove the background color of the scale labels
        showLabelBackdrop: false, // Ensure no label backdrop is shown
        callback: function(value) {
          if (value === -25) return ''; // Hide the -25 label
          return value;
        }
      },
      pointLabels: {
        font: {
           size: 8 //weight: 'bold'
        }
      }
    }
  }
};




function Calls() {
 // const [genstateSum, setGenstateSum] = useState('notgen');
  //const [genstateQA, setGenstateQA] = useState('notgen');
  const [SelectedPeriod, setSelectedPeriod] = useState('Last 30 days');
  //const [genstateTrain, setGenstateTrain] = useState('notgen');
  //const [genstateIdeal, setGenstateIdeal] = useState('notgen');
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [qaActive, setQaActive] = useState(0);
  //const [summaryData, setSummaryData] = useState(null);
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');
 // const [selectedSM] = useState(localStorage.getItem('SM') || 'Jackson Lim');
  //const [smImage, setSmImage] = useState(botProfileIcon);
  //const [shownMessages, setShownMessages] = useState([]);
  const [content, setContent] = useState("");
  const [chartData, setChartData] = useState(null);
  const [dataAvailable, setDataAvailable] = useState(false);
  const resetContent = () => {
    setContent('');
  };
  // useEffect(() => {
  //   const selectedSMProfile = smList.profile.find(profile => profile.name === selectedSM);
  //   // if (selectedSMProfile) {
  //   //   setSmImage(selectedSMProfile.image);
  //   // }
  // }, [selectedSM]);
  
  
  
  const handleSendMessage = () => {
    const trimmedInputValue = inputValue.trim();
    if (trimmedInputValue !== '') {
      // const newMessage = { text: inputValue, sender: 'user' };
      const newMessage = { role: "user", content: trimmedInputValue }; // rename the keys to match the api message
      setMessages([...messages, newMessage]);
      setContent(trimmedInputValue);
      setInputValue('');
      console.log('Input value after clearing:', content);
      
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  // const toggleGenStateSum = () => {
  //   setGenstateSum(prevState => (prevState === 'notgen' ? 'gen' : 'notgen'));
  // };
/*
  const toggleGenStateQA = () => {
    setGenstateQA(prevState => (prevState === 'notgen' ? 'gen' : 'notgen'));
  };

  const toggleGenStateTrain = () => {
    setGenstateTrain(prevState => (prevState === 'notgen' ? 'gen' : 'notgen'));
  };

  const toggleGenStateIdeal = () => {
    setGenstateIdeal(prevState => (prevState === 'notgen' ? 'gen' : 'notgen'));
  };
*/
  const changeActiveTab = (index) => {
    setActiveTabIndex(index);
  };
  
  
  const chartJsData = chartData ? {
    labels: chartData.map(entry => entry.Standard),
    datasets: [{
      label: 'This Call',
      data: chartData.map(entry => entry.Score),
      fill: 'start',
      backgroundColor: 'rgba(7, 115, 234, 0.4)',
      borderColor: 'rgba(7, 115, 234, 0.7)',
      borderWidth: 1,
      pointBackgroundColor: 'rgb(255, 99, 132)',
      pointBorderColor: '#fff',
      pointRadius: 0,
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgb(255, 99, 132)'
    }, {
      label: '30 Days',
      data: [70, 46, 72, 47, 77, 48, 30, 76, 42, 90],
      fill: 'start',
      backgroundColor: 'rgba(175, 189, 202, 0.3)',
      borderColor: 'rgba(175, 189, 202, 0.7)',
      borderWidth: 1,
      pointBackgroundColor: 'rgb(54, 162, 235)',
      pointBorderColor: '#fff',
      pointRadius: 0,
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgb(54, 162, 235)'
    }]
  } : null;

  return (
    <div className="container">
      <Tabs className={`callsTabs ${activeTabIndex===3?'bigpage':''}`} selectedIndex={activeTabIndex} onSelect={(index) => setActiveTabIndex(index)}>
        <TabList>
          <Tab className='defaultTab'>Default</Tab>
          <Tab className='react-tabs__tab outertab'>Call Assessment</Tab>
          <Tab className='react-tabs__tab outertab'onClick={() => { 
                    setQaActive(0); // Set qaActive state to 0
                    //setChartData(null); // Set chartData state to null
                    //setDataAvailable(false);
                  }}>Learning Interventions</Tab>
          <Tab className='react-tabs__tab outertab'onClick={() => { 
                    setQaActive(0); // Set qaActive state to 0
                    //setChartData(null); // Set chartData state to null
                    //setDataAvailable(false);
                  }}>Assistant</Tab>
        </TabList>

        <TabPanel>
          <div className="nextgpt_tab">
            <h1>Get Started</h1>
            <p className="getStarted">Choose any of the quick actions below to get started or type prompts and <br />specific questions for the Assistant to provide additional insights</p>
            <Row>
              <div className="menu">
                <div className="menuBox" onClick={() => changeActiveTab(1)}>
                  <img src={img_callAssessment} alt="" width="40" height="40" /><br />
                  <h5>Call Assessment</h5>
                  <label>Summary and QA of the call</label>
                </div>

                <div className="menuBox" onClick={() => changeActiveTab(2)}>
                  <img src={img_callFollowup} alt="" width="40" height="40" /><br />
                  <h5>Learning Interventions</h5>
                  <label>Training inputs for the RM</label>
                </div>

                <div className="menuBox" onClick={() => changeActiveTab(3)}>
                  <img src={img_nextGPT} alt="" width="40" height="40" /><br />
                  <h5>Assistant</h5>
                  <label>Ask anything to find out more insights</label>
                </div>
              </div>
            </Row>
          </div>
        </TabPanel>
        <TabPanel>
          <div className='assessment_tab'>
            <div className='summary_call'>
              <Tabs>
                <TabList>
                <Tab onClick={() => { 
                    setQaActive(0); // Set qaActive state to 0
                    //setChartData(null); // Set chartData state to null
                    //setDataAvailable(false);
                  }}><img src={summmaryClickIcon} alt="summary icon" />Summary</Tab>
                  <Tab onClick={() => setQaActive(1)}><img src={qaClickIcon} alt="qa icon" />QA Performance</Tab>
                </TabList>
                <TabPanel>
                  <div className='summarytab'>
                    <CallSummary />
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className='qaperformancetab'>
                    <QAPerformance setDataAvailable={setDataAvailable} setChartData={setChartData}/>
                    {/* <Row className='perf_breakdown'>
                      <Col><h5>QA Performance</h5></Col>
                      <Col className='buttoncol'>
                        <button className={`btn ${genstateQA}`} onClick={toggleGenStateQA} ><button className={`btn ${genstateQA}`} onClick={toggleGenStateQA}>
                          {genstateQA === 'notgen' ? (
                            <div className='notgen'>QA Performance</div>
                          ) : (
                            <div className='gen'>
                              <Spinner animation="border" size="sm" />Generating
                            </div>
                          )}
                        </button></button>
                      </Col>
                    </Row> */}
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className='assessment_tab learning_tab'>
            <div className='summary_call'>
              <Tabs>
                <TabList>
                  <Tab><img src={trainingPlanIcon} alt="training plan icon" />Training Plans</Tab>
                  <Tab><img src={idealConversationIcon} alt="ideal conversation icon" />Ideal Conversation</Tab>
                </TabList>
                <TabPanel>
                  <div className='summarytab'>
                   <TrainingPlans />
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className='summarytab'>
                      <IdealConversation />
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </TabPanel>
        <TabPanel className='chatlogcontainer'>
          <Col className='chatlog'>
            <Assistant content={content} messages={messages} setMessages={setMessages} resetContent={resetContent}/>
            {/* {messages.map((message, index) => (
              <div key={index} className={`message ${message.sender}`}>
                <img src={message.sender === 'user' ? smImage : botProfileIcon} alt="Profile Pic" />
                {message.sender === 'user' ? (
                  <span>{message.text}</span>
                ) : (
                  shownMessages.includes(message) ? (
                    <span>{message.text}</span>
                  ) : (
                    <ReactTyped
                      key={index} 
                      strings={[message.text]}
                      typeSpeed={100}
                      backSpeed={50}
                      loop={false}
                      showCursor={false}
                      onComplete={() => setShownMessages(prevShown => [...prevShown, message])}
                    />
                  )
                )}
              </div>
            ))} */}
          </Col>

          <div className='nextgptinput'>
            <InputGroup>
              <Form.Control
                placeholder="Type a message"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <Button onClick={handleSendMessage}>
                <img src={sendMessageIcon} alt="Send Message" />
              </Button>
            </InputGroup>
          </div>
          <div className='ncsrights'>© 2024 NCS Pte Ltd. All rights reserved.</div>
        </TabPanel>
      </Tabs>
      <div className={`graphcontainer ${(qaActive===1)&&(dataAvailable)?'':'hidegraph'}`}>
        <Col>
          <Row className='graphtoprow'>
            <Col className='graphtitle'>Performance Statistics</Col>
            <Col className='dropcol'>
                    <Dropdown className="dropmenu">
                    <Dropdown.Toggle  id="filter">
                      {SelectedPeriod}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item as="button" onClick={() => setSelectedPeriod('Last 30 days')}>Last 30 days</Dropdown.Item>
                      <Dropdown.Item as="button" onClick={() => setSelectedPeriod('Last 3 months')}>Last 3 months</Dropdown.Item>
                      <Dropdown.Item as="button" onClick={() => setSelectedPeriod('Last year')}>Last year</Dropdown.Item>
                    </Dropdown.Menu>
                    </Dropdown>
            </Col>
          </Row>
          {dataAvailable ? <Radar data={chartJsData} options={options} /> : <p>No data available</p>}
        </Col>
            
      </div>
    </div>
  )
}

export default Calls;
